import { create } from "zustand";
import { appSettingsConfig } from "@/lib/constants";

export interface FormState {
	formError: boolean;
	selectedIndex: number;
	isLoading: boolean;
	isPhoneVerified: boolean;
	isSubmitted: boolean;
	validateFormDetails?: () => boolean;
	appSettings: Record<string, string>;
	formContainer: number;
	toggleTC: boolean;
	hasAttemptedSubmit: boolean;

	// Setter functions
	setFormErrors: (hasError: boolean) => void;
	setSelectedIndex: (index: number) => void;
	setLoading: (loading: boolean) => void;
	setPhoneVerified: (isVerified: boolean) => void;
	setIsSubmitted: (isSubmitted: boolean) => void;
	setValidateFormDetails: (fn: () => boolean) => void;
	setAppSettings: (appSettings: string) => void;
	setFormContainer: (size: number) => void;
	setToggleTC: (toggle: boolean) => void;
	setHasAttemptedSubmit: (value: boolean) => void;
}

export const useFormState = () =>
	create<FormState>((set) => ({
		formError: false,
		selectedIndex: 0,
		isLoading: false,
		isPhoneVerified: false,
		isSubmitted: false,
		appSettings: {},
		formContainer: 0,
		toggleTC: false,
		hasAttemptedSubmit: false,

		setFormErrors: (hasError) => set(() => ({ formError: hasError })),
		setSelectedIndex: (index) => set(() => ({ selectedIndex: index })),
		setLoading: (loading) => set(() => ({ isLoading: loading })),
		setPhoneVerified: (isVerified) => set(() => ({ isPhoneVerified: isVerified })),
		setIsSubmitted: (status) => set(() => ({ isSubmitted: status })),
		setValidateFormDetails: (fn) => set(() => ({ validateFormDetails: fn })),
		setAppSettings: (siteTitle) =>
			set(() => ({ appSettings: appSettingsConfig[siteTitle] || {} })),
		setFormContainer: (size) => set(() => ({ formContainer: size })),
		setToggleTC: (toggle) => set(() => ({ toggleTC: toggle })),
		setHasAttemptedSubmit: (value) => set(() => ({ hasAttemptedSubmit: value })),
	}));
